import { Checkbox } from "@mui/material";
import { TreeViewBaseItem } from "@mui/x-tree-view-pro";
import { MdsUnfoldLess, MdsUnfoldMore } from "@sinch/icons";
import { pluck } from "ramda";
import React, { useCallback } from "react";
import { MdsIcon } from "@sinch/components";
import { ExtendedTreeItemProps } from "@sinch/components/application/Rate/RateMigration/types";

interface ExpandCollapseToggleProps {
  /** API reference for the tree view to control expansion */
  apiRef: React.RefObject<any>;
  /** Callback to update the expanded items state */
  onExpandedChange: (expandedItems: string[]) => void;
}

/**
 * Toggle component for expanding/collapsing all tree items.
 * Shows unfold more icon when collapsed, unfold less icon when expanded.
 */
export const ExpandCollapseToggle: React.FC<ExpandCollapseToggleProps> = ({ apiRef, onExpandedChange }) => {
  const handleChange = useCallback<(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void>(
    (_, checked) => {
      if (!apiRef.current) {
        return;
      }
      onExpandedChange(
        checked
          ? (pluck("id", apiRef.current.getItemTree() as TreeViewBaseItem<ExtendedTreeItemProps>[]) as string[])
          : []
      );
    },
    [apiRef, onExpandedChange]
  );
  return (
    <Checkbox
      checkedIcon={<MdsIcon fontSize="xs" icon={MdsUnfoldLess} />}
      icon={<MdsIcon fontSize="xs" icon={MdsUnfoldMore} />}
      onChange={handleChange}
      sx={{ p: 0 }}
    />
  );
};
